// src/pages/IndirectIncomeBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import IndirectIncomeBalanceFilters from "./components/IndirectIncomeBalanceFilters";
import IndirectIncomeBalanceTable from "./components/IndirectIncomeBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportIndirectIncomeBalanceCsv } from "./components/exportIndirectIncomeBalanceCsv";

const { Title } = Typography;

const IndirectIncomeBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list } = useSelector(
    (state) => state.indirectIncomeBalance
  );

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Indirect Income Balance Report",
    removeAfterPrint: true,
  });
const handleDownloadCsv = () => {
    exportIndirectIncomeBalanceCsv({
      list,
      title:    "Indirect Income Balance Report",
      filename: "indirect_income_balance",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} style={{ margin: 0 }} className="reportBigTitle">Indirect Income Balance Report</Title>}
  extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <IndirectIncomeBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <IndirectIncomeBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Indirect Income Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <IndirectIncomeBalanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default IndirectIncomeBalance;
